<template>
  <div
    class="BaseTags">
    <BaseTag
      v-for="(tag, tagIndex) in tags"
      :key="tag + tagIndex"
      :to="{
        name: 'search',
        query: {
          category: tag,
        },
      }">
      {{ tag }}
    </BaseTag>
  </div>
</template>

<script>
import BaseTag from '@/components/BaseTag.vue';

export default {
  name: 'BaseTags',

  components: {
    BaseTag,
  },

  props: {
    tags: { type: Array, required: true },
  },
};
</script>
